import { render } from "./NoraBubble.vue?vue&type=template&id=00167762&scoped=true"
import script from "./NoraBubble.vue?vue&type=script&lang=js"
export * from "./NoraBubble.vue?vue&type=script&lang=js"

import "./NoraBubble.vue?vue&type=style&index=0&id=00167762&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00167762"]])

export default __exports__